import type BeneficiaryDirectoryEntryView from '@UI/Store/Beneficiaries/Views/BeneficiaryDirectoryEntryView';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * Resolves a beneficiary's display name from `{ id }` relations sent elsewhere — the supervision list
 * never carries a name inline. `facilityId`/`assignedUserId` are the scope this directory was fetched
 * for, compared by the screen's `stopOn` to decide whether it still applies.
 */
class BeneficiaryDirectoryListView {
	readonly facilityId: number;
	readonly assignedUserId: number | null;
	readonly entries: readonly BeneficiaryDirectoryEntryView[];
	private readonly namesById: ReadonlyMap<number, string>;

	constructor(
		facilityId: number,
		assignedUserId: number | null,
		entries: readonly BeneficiaryDirectoryEntryView[],
	) {
		this.facilityId = facilityId;
		this.assignedUserId = assignedUserId;
		this.entries = entries;
		this.namesById = new Map(entries.map((entry) => [entry.id, entry.fullName]));

		Object.freeze(this);
	}

	nameOf(id: number): string | null {
		return this.namesById.get(id) ?? null;
	}
}

export default BeneficiaryDirectoryListView;
